enum CategoryLabel {
  COLOUR = 'Colour',
  INTERIOR = 'Interior',
  EXTERIOR = 'Exterior',
}

export default CategoryLabel;
